// Utility function for consistent dropdown positioning
export const getDropdownMenuProps = () => ({
  PaperProps: {
    style: {
      maxHeight: 300,
      zIndex: 9999,
      position: 'fixed' as const,
    },
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
  disableAutoFocusItem: true,
  disableEnforceFocus: true,
  disableRestoreFocus: true,
  // Additional positioning fixes
  style: {
    zIndex: 9999,
  },
  BackdropProps: {
    style: {
      zIndex: 9998,
    },
  },
});

// Alternative configuration for better positioning
export const getDropdownMenuPropsAlternative = () => ({
  PaperProps: {
    style: {
      maxHeight: 300,
      zIndex: 9999,
      position: 'absolute' as const,
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
    },
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
  disableAutoFocusItem: true,
  disableEnforceFocus: true,
  disableRestoreFocus: true,
});
